/**
 * Shared disclaimer / legal-helper text strings used across the listing UI.
 *
 * Strings here have legal review attached — do not edit without coordinating
 * with the real-estate-law-expert agent.
 */

/**
 * Help-text shown next to the seller-entered room dimensions / sqft inputs.
 * Source: docs/legal/reviews (room-dimensions clause). The frontend renders
 * this verbatim under L/W inputs and other MLS data fields.
 */
export const MLS_DATA_DISCLAIMER =
  'Room dimensions and square footage provided by seller; buyer to verify.';

/**
 * The standard legal disclaimer, shown verbatim as its own paragraph on
 * screens where a user prepares or signs a legal document (e.g. the Wisconsin
 * condition report).
 */
export const LEGAL_DISCLAIMER =
  'DISCLAIMER: The information provided is for general educational purposes only and does not constitute legal advice. Real estate laws vary by jurisdiction and change over time. Always consult a licensed real estate attorney in your area before making legal decisions.';

/**
 * Fine print for the pricing page. Source: real-estate-law-expert review of the
 * 2026-09-27 pricing tiers (fee framing per
 * docs/plans/stripe-billing/08-legal-review.md §3.1–3.3).
 */
export const PRICING_DISCLAIMER =
  'Cut the 6 is a software platform. It is not a licensed real estate broker or brokerage, and not a law firm. We do not act as agent for any party, negotiate on your behalf, or give legal, tax, or appraisal advice. All fees are flat software-access fees, not commissions or a percentage of any price, and are never collected from sale proceeds. Commission comparisons are illustrative estimates; commissions vary and are negotiable.';

const disclaimers = {
  MLS_DATA_DISCLAIMER,
  LEGAL_DISCLAIMER,
  PRICING_DISCLAIMER,
};

export default disclaimers;

/**
 * Fine print under every offer / counter-offer acceptance-deadline field.
 * Source: docs/legal/reviews/2026-09-29-offer-acceptance-deadline.md §11
 * (Model A: the contract forms when everyone signs the purchase agreement).
 */
export const OFFER_DEADLINE_DISCLAIMER =
  "Setting a deadline doesn't make your offer binding or stop you from withdrawing it. No contract exists until everyone signs the purchase agreement. General information only, not legal advice. Rules vary by state, so consult a licensed real estate attorney.";
